import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export const useCommentActions = () => {
  const queryClient = useQueryClient();

  const approveComment = useMutation({
    mutationFn: async ({ postCommentId, status, remarks }) => {
      const updatedBy = localStorage.getItem('userName') || 'User';
      const payload = { postCommentId, status, updatedBy };
      if (status === 'rejected' && remarks) {
        payload.remarks = remarks;
      }
      const response = await apiClient.post('/approve/comment', payload);

      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Failed to process comment');
      }

      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch comments
      queryClient.invalidateQueries(['comments']);
    }
  });

  return {
    approveComment
  };
}; 